import { render } from "./Roles.vue?vue&type=template&id=501a2f1e&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=501a2f1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-501a2f1e"

export default script